import axios from 'axios'
import HTTP from './http'

export default {
    initSendCode: payload => axios.post(HTTP.INSURANCE_CRAWLER_INIT_SEND_CODE, { ...payload }),
    authUser: payload => axios.post(HTTP.INSURANCE_CRAWLER_AUTH_USER, { ...payload })
}
